import * as React from 'react';
import { WhiteLabelMobileHeader } from '@mitchell/react.component.ux';
import { TranslationService } from "../../common";
import { DOWNLOAD_ARTIFACT, DOWNLOAD_ARTIFACT_MESSAGES, PhotoCaptureConstants } from '../constants';
import { DownloadArtifactsGalleryComponent } from './DownloadArtifactsGalleryComponent';
import { IntelligentPhotoCaptureShowMessagePage } from './intelligentComponents';
export const DownloadArtifactsComponent = ({ photoCaptureAttachmentInfo, downloadArtifactAuthDetailsInfo, appTheme, countryCode, contextId, companyCode, language, onHandleReactivationCall, onDownloadStart, onDownloadComplete }) => {
    const translateFn = TranslationService.translate;
    const { downloadLinkExpired, reactivateAllowed } = downloadArtifactAuthDetailsInfo || {
        downloadAllowed: false,
        downloadLinkExpired: true,
        reactivateAllowed: false
    };
    // Handler for reactivation button
    const handleReactivation = React.useCallback(() => {
        if (contextId && companyCode && onHandleReactivationCall) {
            onHandleReactivationCall(companyCode, contextId);
        }
    }, [contextId, companyCode]);
    // Case 2: Download link expired with reactivation not allowed
    if (downloadLinkExpired && !reactivateAllowed) {
        return (React.createElement(IntelligentPhotoCaptureShowMessagePage, { appTheme: appTheme, message: DOWNLOAD_ARTIFACT_MESSAGES.DOWNLOAD_LINK_EXPIRED_MESSAGE, shouldShowButton: false }));
    }
    // Case 3: Download link expired but reactivation is allowed
    if (downloadLinkExpired && reactivateAllowed) {
        return (React.createElement(IntelligentPhotoCaptureShowMessagePage, { appTheme: appTheme, message: DOWNLOAD_ARTIFACT_MESSAGES.REACTIVATION_LIMIT_EXPIRED, shouldShowButton: true, buttonProps: {
                id: 'messagePage_RenewButton_id',
                label: DOWNLOAD_ARTIFACT.RENEW_BUTTON_LABEL,
                onClick: handleReactivation,
                isDisabled: false,
                buttonBackgroundColor: appTheme.buttonBackgroundColor,
                buttonTextColor: appTheme.buttonTextColor
            } }));
    }
    // Case 4: Download is allowed, link not expired - show gallery
    return (React.createElement(React.Fragment, null,
        React.createElement(WhiteLabelMobileHeader, { headerText: translateFn(PhotoCaptureConstants.DOWNLOAD_IMAGES), headerBackgroundColor: appTheme.headerBackgroundColor, headerColor: appTheme.headerColor }),
        React.createElement(DownloadArtifactsGalleryComponent, { photoCaptureAttachmentInfo: photoCaptureAttachmentInfo, appTheme: appTheme, countryCode: countryCode, language: language, onDownloadStart: onDownloadStart, onDownloadComplete: onDownloadComplete })));
};
//# sourceMappingURL=DownloadArtifactsComponent.js.map